<div class="pay-app-summary">
  <!-- Header -->
  <div class="summary-header">
    <div class="title-section">
      <h2>{{ payApp?.name || 'Pay Estimate #' + payApp?.estimate_number }}</h2>
      @if (formatPeriod()) {
        <span class="period">Period: {{ formatPeriod() }}</span>
      }
    </div>
    <div class="status-badge" [ngClass]="payApp?.status">
      {{ payApp?.status | titlecase }}
    </div>
  </div>

  <div class="summary-table">
    <!-- Deductions -->
    <div class="table-cell">
      <h3 class="section-title">Deductions</h3>
      <div class="cell-content">
        <div class="summary-row">
          <span class="label">Retainage ({{ deductions.retainagePercent }}%):</span>
          <span class="value deduction">{{ deductions.retainageAmount | currency:'USD' }}</span>
        </div>
        <div class="summary-row">
          <span class="label">Retainage released:</span>
          <span class="value addition">{{ deductions.retainageReleased | currency:'USD' }}</span>
        </div>
        <div class="summary-row subtotal">
          <span class="label">Net retainage:</span>
          <span class="value">{{ deductions.netRetainage | currency:'USD' }}</span>
        </div>
        @if (deductions.liquidatedDamagesDays > 0) {
          <div class="summary-row">
            <span class="label">Liquidated damages ({{ deductions.liquidatedDamagesDays }} days):</span>
            <span class="value deduction">{{ deductions.liquidatedDamagesAmount | currency:'USD' }}</span>
          </div>
        }
        @if (deductions.liquidatedDamagesDays === 0) {
          <div class="summary-row">
            <span class="label">Liquidated damages:</span>
            <span class="value">$0.00</span>
          </div>
        }
        <div class="summary-row total">
          <span class="label">Total deductions:</span>
          <span class="value deduction">{{ deductions.totalDeductions | currency:'USD' }}</span>
        </div>
      </div>
    </div>

    <!-- Amount Due -->
    <div class="table-cell amount-due-cell">
      <h3 class="section-title">Amount due</h3>
      <div class="cell-content">
        @if (hasMohLedger) {
          <div class="summary-row">
            <span class="label">Work completed to date:</span>
            <span class="value">{{ earningsToDate.workCompletedToDate | currency:'USD' }}</span>
          </div>
          <div class="summary-row">
            <span class="label">Stored to date:</span>
            <span class="value">{{ earningsToDate.materialOnHand | currency:'USD' }}</span>
          </div>
          <div class="summary-row">
            <span class="label">Advanced this period:</span>
            <span class="value addition">{{ earningsToDate.mohAdvancedThisPeriod | currency:'USD' }}</span>
          </div>
          <div class="summary-row">
            <span class="label">Drawn down this period:</span>
            <span class="value deduction">{{ earningsToDate.mohDrawdownThisPeriod | currency:'USD' }}</span>
          </div>
          <div class="summary-row subtotal">
            <span class="label">Total completed and stored:</span>
            <span class="value">{{ amountDue.totalEarningsToDate | currency:'USD' }}</span>
          </div>
        } @else if (earningsToDate.materialOnHand > 0) {
          <div class="summary-row">
            <span class="label">Work completed to date:</span>
            <span class="value">{{ earningsToDate.workCompletedToDate | currency:'USD' }}</span>
          </div>
          <div class="summary-row">
            <span class="label">Material on hand:</span>
            <span class="value">{{ earningsToDate.materialOnHand | currency:'USD' }}</span>
          </div>
          <div class="summary-row subtotal">
            <span class="label">Total earnings to date:</span>
            <span class="value">{{ amountDue.totalEarningsToDate | currency:'USD' }}</span>
          </div>
        } @else {
          <div class="summary-row">
            <span class="label">Total earnings to date:</span>
            <span class="value">{{ amountDue.totalEarningsToDate | currency:'USD' }}</span>
          </div>
        }
        <div class="summary-row">
          <span class="label">Less total deductions:</span>
          <span class="value deduction">{{ amountDue.lessTotalDeductions | currency:'USD' }}</span>
        </div>
        <div class="summary-row">
          <span class="label">Less previous payments:</span>
          <span class="value deduction">{{ amountDue.lessPreviousPayments | currency:'USD' }}</span>
        </div>
        <div class="summary-row grand-total">
          <span class="label">Amount due this period:</span>
          <span class="value primary">{{ amountDue.amountDueThisPeriod | currency:'USD' }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
